import React from 'react';
import { useLabels } from 'wsm-common-data';
import { useSelector } from 'react-redux';

const VehiclesDetailsButtonRow = () => {
	const vehicles = useSelector((state) => state.vehicles);
	const labels = useLabels();

	return (
		<tr>
			{vehicles.map((vehicle, idx) => {
				return (
					<td
						key={`btn-details-${vehicle.uuid}`}
						className={`compare-item col-${idx + 1}`}
					>
						{vehicle.link && (
							<a
								className="btn btn-primary btn-block mt-3 mb-3"
								href={`${vehicle.link}`}
							>
								{labels.get('VIEW_DETAILS')}
							</a>
						)}
					</td>
				);
			})}
		</tr>
	);
};

export default VehiclesDetailsButtonRow;
